"use client"; // This is required for Next.js 14 to handle client-side form events

import { useState } from "react";
import "./ContactForm.scss";
// import  "./ReservationForm.scss";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    options: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission, e.g., send data to an API
    console.log(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <label htmlFor="name">YOUR NAME*</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name here"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">YOUR EMAIL*</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email here"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="subject">CONTACT NUMBER*</label>
        <input
          type="text"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          placeholder="Phone number here"
          required
        />
      </div>

      <div className="form-group">
  <label htmlFor="options">SELECT AN OPTION*</label>
  <select
    id="options"
    name="options"
    value={formData.options}
    onChange={handleChange}
    required
  >
    <option value="" disabled>
    Choose a store
    </option>
    <option value="Option 1">Option 1</option>
    <option value="Option 2">Option 2</option>
    <option value="Option 3">Option 3</option>
  </select>
</div>

      <div className="form-group">
        <label htmlFor="message">YOUR MESSAGE</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Enter your message here"
          required
        />
      </div>

   <div className="d-flex space-between">
        <button type="submit" className="submit-button">
          SEND
        </button>
        <button type="submit" className="submit-button">
        BECOME A FRANCHISEE
        </button>
   </div>
    </form>
  );
};

export default ContactForm;
